import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import FactoryRushCapacityProductGroupMember from "./factory-rush-capacity-product-group-member.model";

export default class FactoryRushCapacityProductGroupMemberFactory
  implements ObjectBuilderInterface<FactoryRushCapacityProductGroupMember> {
  public buildFromJSON(data: {
    [key: string]: any;
  }): FactoryRushCapacityProductGroupMember {
    const value = new FactoryRushCapacityProductGroupMember(
      data.product.toString(),
      data.productGroup
    );

    value.isNew = false;

    return value;
  }
}
